import { createContext, RefObject, useContext } from 'react';

interface PageScrollContextValue {
  scrollableContentRef: RefObject<HTMLElement>;
}

export const PageScrollContext = createContext<PageScrollContextValue>({
  scrollableContentRef: { current: null },
});

export const usePageScrollContext = () => useContext(PageScrollContext);
